import React from "react";
import Start3 from "./Class 3/Start3";
import "./App.css"
function App() {
  return <div>
    <Start3/>
  </div>;
}

export default App;
